import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SocialAdd, SocialGrid, SocialIcon, SocialItem, SocialName, SocialVal, } from "./profile.style";
import { SOCIAL_PLATFORM_META } from "./profile.utils";
var ProfileSocialGrid = function (_a) {
    var links = _a.links, _b = _a.editable, editable = _b === void 0 ? false : _b, onEdit = _a.onEdit;
    return (_jsx(SocialGrid, { children: links.map(function (link) {
            var _a, _b;
            var meta = (_a = SOCIAL_PLATFORM_META[link.platform]) !== null && _a !== void 0 ? _a : {
                icon: "🔗",
                bg: "#f5f5f5",
                prefix: "",
            };
            var hasHandle = !!((_b = link.handle) === null || _b === void 0 ? void 0 : _b.trim());
            var openLink = function () {
                if (link.url) {
                    window.open(link.url, "_blank", "noopener,noreferrer");
                }
                else if (editable && onEdit) {
                    onEdit();
                }
            };
            return (_jsxs(SocialItem, { type: "button", onClick: openLink, children: [_jsx(SocialIcon, { "$bg": meta.bg, children: meta.icon }), _jsxs("div", { style: { flex: 1, minWidth: 0 }, children: [_jsx(SocialName, { children: link.label }), _jsx(SocialVal, { "$empty": !hasHandle, children: hasHandle ? "@".concat(link.handle) : "Not added yet" })] }), hasHandle ? (_jsx("span", { style: { color: "#7a7368", fontSize: 12 }, children: "\u2197" })) : editable ? (_jsx(SocialAdd, { children: "+ Add" })) : null] }, link.platform));
        }) }));
};
export default ProfileSocialGrid;
